import { Button } from '@mui/material';
import LoopIcon from '@mui/icons-material/Loop';
import i18n from '@shared/config/i18n';

const { t } = i18n;

const getActivity = ({ columns, tableData, hiddenColumnNames }) => {
  const withoutHiddenColumns = !columns && !hiddenColumnNames;

  let hasLeastOneVisibleColumn = false;
  let dataExists = false;

  if (!withoutHiddenColumns) {
    hasLeastOneVisibleColumn = columns.length !== hiddenColumnNames.length;
  }

  if (tableData) {
    dataExists = tableData.length;
  }
  return (withoutHiddenColumns || hasLeastOneVisibleColumn) && dataExists;
};

const ChangeEmployeeButton = (props) => {
  const {
    onClick = () => {},
    columns,
    tableData,
    hiddenColumnNames,
    active = false,
    ...rest
  } = props;

  const isActive =
    active == false ? getActivity({ columns, tableData, hiddenColumnNames }) : true;

  return (
    <Button
      startIcon={<LoopIcon />}
      onClick={onClick}
      disabled={!isActive}
      color="primary"
      variant="outlined"
      {...rest}
    >
      {t('SubstituteWorker.popover')}
    </Button>
  );
};

export { ChangeEmployeeButton };
